import React, { useCallback } from 'react';
import Flag from 'react-flagkit';

export const useGetCultureIcon = () => {
  return useCallback((culture: string) => {
    return <Flag country={culture.slice(-2)} />;
  }, []);
};
